/**
 * useColdProjects Hook
 *
 * Wrapper around useUnifiedProjects for Flux COLD app.
 * Provides CRUD operations for cold storage projects.
 */

import { useUnifiedProjects } from '@vortx/shared-ui';

// Get API URL from environment (baked in at build time)
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export function useColdProjects() {
    return useUnifiedProjects('flux_cold', API_BASE_URL);
}
